// sgi/apps/frontend/ui-enrollment/src/api.ts
import axios from 'axios'
import Cookies from 'js-cookie'

const API_URL = (window as any).SGI_API ?? 'http://localhost:3000'

export const api = axios.create({
  baseURL: API_URL,
  timeout: 30000,
  headers: { 'Content-Type': 'application/json' },
})

api.interceptors.request.use((config) => {
  const temp = Cookies.get('sgi-temp-token')
  if (temp) config.headers['sgi-temp-token'] = temp
  return config
})

api.interceptors.response.use(
  (res) => res,
  (err) => {
    // if (err.response?.status === 401) {
    //   Cookies.remove('sgi-temp-token')
    //   window.location.reload()
    // }
    return Promise.reject(err)
  }
)